
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'Icon'
})
export default class Icon extends Vue {
  @Prop({ required: true, default: 'settings' }) name!: string
  @Prop({ type: String }) color!: string
  @Prop({ type: String }) fill!: string
  @Prop({ type: String }) stroke!: string
  @Prop({ type: String, default: 'icon' }) ariaLabel!: string
  @Prop({ type: String, default: 'span' }) type!: string
  @Prop({ type: String, default: '13' }) size!: string
}
